import type { InjectionKey } from 'vue';

export type SortDir = '' | 'asc' | 'desc';

// Config as declared by op-th (raw, before % → px conversion)
export interface ColumnConfig {
    width?: number | string;
    minWidth?: number | string;
    maxWidth?: number | string;
    resizable?: boolean;
}

// Column state after resolution, kept in opTable
export interface ResolvedColumn {
    currentWidth: number;   // always px
    minWidth: number;       // px
    maxWidth: number;       // px, Infinity = no limit
    resizable: boolean;
    _raw: ColumnConfig;     // original props for re-resolution on resize
}

export interface OpTableContext {
    registerColumn(config: ColumnConfig): number;
    updateColumnWidth(colIndex: number, width: number): void;
    resetColumnWidth(colIndex: number): void;
    getSort(): { key?: string; dir: SortDir };
    setSort(key?: string, dir?: SortDir): void;
    getColumnCount(): number;
}

export const OP_TABLE_CTX: InjectionKey<OpTableContext> = Symbol('OP_TABLE_CTX');

export interface PaginationChangePayload {
    page: number;
    pageSize: number;
    sortKey: string;
    sortDir: SortDir;
}
